<div class="row basic-component">
    <div class="col-sm-12">
        <form [formGroup]="registrantForm" name="registrantForm" novalidate role="form">
            <div class="row">
                <div class="col-sm-12 section-title" tabindex="0">
                  <span>Registrant</span>
                  <span class="float-end create-company-link" *ngIf="canCreateCompany">
                    <a href="javascript:void(0);" (click)="showCompanyDialog()" (keydown.enter)="showCompanyDialog()" tabindex="0"
                        class="create-company-link" id="create-company"><small>Create new company</small></a>
                  </span>
              </div>
            </div>
            <div class="row">
                <div class="col-sm-12 no-padding">
                    <table class="table table-inline table-bordered">
                        <tbody>
                            <tr>
                                <th class="text-center">
                                    <label id="registrant-rCompanyRevisionId-label" aria-label="Company Name / Company DUNS" class="form-label-control">Company Name / Company DUNS</label>
                                </th>
                                <th class="text-center">
                                    <label id="registrant-confidentiality-label" aria-label="Confidentiality" class="form-label-control">Confidentiality</label>
                                </th>
                            </tr>
                            <tr>
                                <td class="td-50">
                                    <div class="row">
                                        <div class="mb-3 col-sm-12">
                                            <ejs-dropdownlist #rCompanyDdw [dataSource]="companyDataSource"
                                                              [fields]="companyFields" [placeholder]="waterMark"
                                                              [popupHeight]="ddwHeight" aria-labelledby="registrant-rCompanyRevisionId-label"
                                                              [(value)]="rCompanyRevisionId" allowFiltering=true filterType="Contains"
                                                              formControlName="rCompanyRevisionId" (change)="ddwChange($event)">
                                            </ejs-dropdownlist>
                                        </div>
                                        <div class="row" *ngIf="isCompanyInactive">
                                            <app-warning-icon #warningContact [name]="inactiveLabelerContactName" [type]="iconTypeCompany"></app-warning-icon>
                                        </div>
                                    </div>
                                </td>

                                <td>
                                    <div class="row">
                                        <div class="col-sm-12">
                                          <div class="row">
                                            <div class="col-sm-5 text-end">

                                              <ejs-radiobutton #yesRadio label='Yes' value="Y"
                                                               name="registrantConfidentiality" aria-labelledby="registrant-confidentiality-label"
                                                               formControlName="registrantConfidentiality" labelPosition="Before" (change)="registrantConfidentialityChange('Y')">
                                              </ejs-radiobutton>

                                            </div>
                                            <div class="col-sm-1"></div>
                                            <div class="col-sm-6 text-start">
                                              <ejs-radiobutton #noRadio label='No' value="N" name="registrantConfidentiality" labelPosition="Before" 
                                                               aria-labelledby="registrant-confidentiality-label" formControlName="registrantConfidentiality" (change)="registrantConfidentialityChange('N')"></ejs-radiobutton>
                                            </div>
                                          </div>
                                        </div>
                                    </div>

                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>

        </form>
    </div>
</div>

<!-- Company Detail Dialog box -->
<ejs-dialog id='dialog' #companyDialog isModal='true'
            [animationSettings]='animationSettings' [visible]='hidden' width="80%">
    <ng-template #content class="modal-header">
        <form name="modalCompanyForm">
            <div class="card">
                <div class="card-header bg-primary">
                    <h4 class="card-title text-white">Company Details</h4>
                </div>

                <div class="card-body">
                    <app-company-details #companyDetails (companyOutput)="modalCompany($event)"
                        (cancelButtonClickedOutput)="companyDialogCancelButtonClicked()"
                        [parentComponentInput]="parentComponent">
                    </app-company-details>
                </div>

            </div>

        </form>
    </ng-template>
</ejs-dialog>
